module.exports = __webpack_public_path__ + "img/mizhi-back-three@2x.97312f81.png";